/* Mirrors src/hooks/use-breakpoint.ts (Breakpoints.lg=1024).

   filters-bar.tsx picks one of two entirely different markups (a horizontal
   chip scroller vs. a vertical list) with a JS `isLg` check that only
   resolves after mount — on desktop this meant rendering the chip-scroller
   first, then swapping to the vertical list a moment later, a large height
   jump in the sidebar. Both variants are rendered here and toggled with
   `display` behind a media query instead, so the browser picks the right
   one at first paint. useFilters() state is shared context, not per-instance,
   so having both mounted doesn't duplicate data fetching or desync input. */

.mobileOnly {
  display: block;
}

.desktopOnly {
  display: none;
}

@media (min-width: 1024px) {
  .mobileOnly {
    display: none;
  }

  .desktopOnly {
    display: block;
  }
}
